import styled from 'styled-components'

export const AppContainer = styled.div`
  display: flex;
  height: 100dvh;
  width: 100dvw;
  position: relative;
  overflow: hidden;
`
